module.exports = __webpack_public_path__ + "static/img/Firstname-Lastname.7cc576d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Firstname-Lastname.jpg
// module id = at+X
// module chunks = 1